import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const borrowerUserApiSlice = createApi({
  reducerPath: "borrowerUserApi",
  baseQuery: async (args, api, extraOptions) => {
    const result = await fetchBaseQuery({ 
      baseUrl: "https://moneylend.dockyardsoftware.com/",
      prepareHeaders: (headers, { getState }) => {
        const token = localStorage.getItem("token");
        if (token) headers.set("authorization", `Bearer ${token}`);
        return headers;
      },
    })(args, api, extraOptions);

    // Check if response indicates error (statusCode != 1 and statusCode != 200)
    if (result.data && typeof result.data === 'object' && 'StatusCode' in result.data) {
      if (result.data.StatusCode !== 1 && result.data.StatusCode !== 200) {
        return {
          error: {
            status: result.data.StatusCode,
            data: result.data,
          },
        };
      }
    }

    return result;
  },
  tagTypes: ["Borrower"],
  endpoints: (builder) => ({
    // Get all borrowers with complete details
    getAllBorrowers: builder.query({
      query: () => "Borrower/GetAllBorrowers",
      transformResponse: (response) => {
        // Extract ResultSet from response
        return response?.ResultSet || [];
      },
      providesTags: ["Borrower"],
    }),

    // Get single borrower by ID
    getBorrowerById: builder.query({
      query: (borrowerId) => `Borrower/GetBorrowerById?borrowerId=${borrowerId}`,
      transformResponse: (response) => {
        // API returns ResultSet as array; return first item or null
        const set = response?.ResultSet;
        return Array.isArray(set) && set.length > 0 ? set[0] : null;
      },
      providesTags: ["Borrower"],
    }),

      // Update user (Admin)
  updateUser: builder.mutation({
    query: (payload) => ({
      url: `User/UpdateUser/${payload.userId}`,
      method: "PUT",
      body: payload,
    }),
    invalidatesTags: ["User"],
  }),

    // Update borrower details (firstName, lastName, nic, address, dob, occupation)
    updateBorrowerUser: builder.mutation({
      query: (payload) => ({
        url: `Borrower/UpdateBorrower/${payload.borrowerId}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["Borrower"],
    }),
  })
});

export const {
  useGetAllBorrowersQuery,
  useGetBorrowerByIdQuery,
  useUpdateUserMutation,
  useUpdateBorrowerUserMutation,
} = borrowerUserApiSlice;
